import React from "react";
import { Chip } from "@mui/material";
import { ETicketStatus, ETicketStatusColors } from "../../Utils/Enums";
import { Vocabulary } from "../../Utils/Vocabulary";

interface StatusChipProps {
  status: string;
  size?: "small" | "medium";
}

const StatusChip: React.FC<StatusChipProps> = ({ status, size = "small" }) => {
  const getStatusLabel = (status: string): string => {
    switch (status) {
      case ETicketStatus.NEW:
        return Vocabulary.statusNew;
      case ETicketStatus.ONGOING:
        return Vocabulary.statusOngoing;
      case ETicketStatus.RESOLVED:
        return Vocabulary.statusResolved;
      case ETicketStatus.CLOSED:
        return Vocabulary.statusClosed;
      default:
        return status;
    }
  };

  const getStatusColor = (status: string): string => {
    switch (status) {
      case ETicketStatus.NEW:
        return ETicketStatusColors.NEW;
      case ETicketStatus.ONGOING:
        return ETicketStatusColors.ONGOING;
      case ETicketStatus.RESOLVED:
        return ETicketStatusColors.RESOLVED;
      case ETicketStatus.CLOSED:
        return ETicketStatusColors.CLOSED;
      default:
        return "#666";
    }
  };

  return (
    <Chip
      label={getStatusLabel(status)}
      size={size}
      sx={{
        backgroundColor: getStatusColor(status),
        color: "#fff",
        fontWeight: "bold",
      }}
    />
  );
};

export default StatusChip;
